import React from 'react'
import PropTypes from 'prop-types'
const sizes = ['medium', 'medium_large']

const DynamiteAttachment = props => {
  return <img src={props.item.sources[sizes[props.sizeIndex]][0]} style={{ display: 'block' }} />
}

DynamiteAttachment.defaultProps = {
  sizeIndex: 0
}

DynamiteAttachment.propTypes = {
  sizeIndex: PropTypes.number,
  item: PropTypes.object.isRequired
}

export default DynamiteAttachment
